<template>
  <div class="lp-time-picker-container">

    <div class="sort-drdn-time">
      <div class="sort-drdn-select-wrapper" @click.stop.prevent="openList" :style="wrapperStyle" style="margin-bottom:12px;">
        <div class="sort-drdn-select-item" @click.stop.prevent="openList">
          <span class="sel-time">{{ selTime.hour }}</span>
          <span class="sel-time">&#58;</span>
          <span class="sel-time">{{ selTime.minute }}</span>
        </div>
        <i v-if="!isOpen" @click.stop.prevent="isOpen=true" class="material-icons sort-drdn-arrow-icon">keyboard_arrow_down</i>
        <i v-if="!!isOpen" @click.stop.prevent="isOpen=false" class="material-icons sort-drdn-arrow-icon">keyboard_arrow_up</i>
      </div>
      <div v-if="!!isOpen" class="sort-drdn-list-outsider" @click="isOpen=false"></div>
      <div class="hour-minute-group" v-if="!!isOpen">
        <!-- Hour Picker -->
        <div class="sort-drdn-list-wrapper hours-wrapper" :style="listWrapperStyle">
          <ul class="sort-drdn-list" :style="listStyle" style="list-style: unset;margin-left: 0;margin-top: 0">
            <li class="sort-drdn-item"
                v-for="(item,idx) in hours" :key="'sort-list'+idx"
                :class="{'is-selected': item === selTime.hour}"
                @click="clickTargetItem(item, 'hour')" :style="itemStyle">{{ item }}</li>
          </ul>
        </div>
        <!-- Minute Picker -->
        <div class="sort-drdn-list-wrapper minutes-wrapper" :style="listWrapperStyle">
          <ul class="sort-drdn-list" :style="listStyle" style="list-style: unset;margin-left: 0;margin-top: 0">
            <li class="sort-drdn-item" v-for="(item,idx) in minutes" :key="'sort-list'+idx" @click="clickTargetItem(item, 'minute')" :style="itemStyle">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
  props: ['type', 'time', 'placeholder', 'nowOpened', 'wrapWidth', 'listWidth', 'bgColor', 'borderColor'],
  components: {
    Datepicker
  },
  data() {
    return {
      isOpen: false,
      regionList: [],
      selTime: {
        hour: '',
        minute: ''
      },
      hours: [],
      minutes: []
    }
  },
  created() {
    if(this.time){
      let times = this.time.split(':');
      this.selTime = {
        hour: times[0],
        minute: times[1]
      }
    }

    // // 오픈 시 열려있는 다른 리스트 닫기
    // if ( this.nowOpened !== this.type ){
    //   this.isOpen = false;
    // }

    // if ( this.type === 'time' ) {
      this.makeTime();
    // }
  },
  watch: {
    time(n){
      let times = n.split(':');
      this.selTime = {
        hour: times[0],
        minute: times[1]
      }
    },
    nowOpened(n) {
    if ( n !== this.type ){
        this.isOpen = false;
      }
    }
  },
  computed: {
    wrapperStyle() {
      let style = {};

      if ( this.listWidth !== undefined ) {
        style.width = this.listWidth + 'px';
      }
      if ( this.bgColor !== undefined ) {
        style.backgroundColor = this.bgColor;
      }
      if ( this.borderColor !== undefined ) {
        style.border = '1px solid ' + this.borderColor;
      }

      return style;
    },
    listWrapperStyle() {
      let style = {};

      if ( this.listWidth !== undefined ) {
        style.width = parseInt(this.listWidth) - 17 + 'px';

      }
      if ( this.borderColor !== undefined ) {
        style.border = '1px solid ' + this.borderColor;
      }

      return style;
    },
    listStyle() {
      let style = {};

      if ( this.listWidth !== undefined ) {
        style.width = this.listWidth + 'px';


      }

      return style;
    },
    itemStyle() {
      let style = {};

      if ( this.bgColor !== undefined ) {
        style.backgroundColor = this.bgColor;
      }

      return style;
    }
  },
  methods: {
    openList() {
      this.isOpen ? this.isOpen=false : this.isOpen=true;
      this.$root.$emit('openListType', this.type);
    },
    clickTargetItem(item, type) {

      if ( type === 'hour') {
        this.selTime.hour = item;
      }
      else if ( type === 'minute') {
        this.selTime.minute = item;
      }

      this.$emit('onSelect', this.selTime);
      this.$emit('update:time', '%s:%s'.format(this.selTime.hour, this.selTime.minute));
      if(type === 'minute')
        this.isOpen = false;
    },
    makeTime(){
      for (let i=0; i<=23; i++) {
        let hour = i.toString();
        if ( hour.length === 1 ) hour = '0' + hour;
        this.hours.push(hour);
      }

      for (let i=0; i<=50; i+=10) {
        let minute = i.toString();
        if ( minute.length === 1 ) minute = '0' + minute;
        this.minutes.push(minute);
      }



    }
  }
}
</script>

<style lang="stylus" type="stylus" scoped>

.sort-drdn-time
  font-size 0.9rem
  position relative

.sort-drdn-select-wrapper
  // background #f2f7f8
  background-color #fff
  display flex
  justify-content space-between
  width 100px
  border-bottom 2px solid #ccc
  height 36px
  padding 8px 12px

.sort-drdn-select-item
  display flex
  align-items center
  justify-content center

.sel-time
  width 16px
  text-align center

.sort-drdn-arrow-icon
  font-size 20px
  color #064160

.sort-drdn-list-wrapper
  position absolute
  top -70px
  z-index 1
  overflow hidden
  width 42px
  border 1px solid #ddd
.hours-wrapper
  left 13px
.minutes-wrapper
  left 54px

.sort-drdn-list
  // background #f2f7f8
  // box-shadow 3px 4px 8px 0px #999
  background-color #fff
  border-radius 3px
  max-height 168px
  // width 146px
  overflow-y auto
  width 60px

.sort-drdn-item
  // background #f2f7f8
  padding 6px 10px 6px 12px

.sort-drdn-item:hover
  background #ddd
  cursor pointer

.sort-drdn-list-outsider
  position fixed
  top 0
  left 0
  right 0
  bottom 0

.sort-drdn-date
  position absolute
  top -14px
  left 0

.is-selected
  color #008fd9

// .sort-date-picker-input
//   border none
//   background transparent
//   height 30px


</style>
